import { WorkspaceT } from '@/pages/workgroup/type';

export type ViewMode = 'graph' | 'table' | 'card';

export type AccessFilter = 'all' | 'rw' | 'ro';

export type StatusFilter = 'all' | 'active' | 'stopped' | 'pending' | 'idle' | 'error' | 'degraded' | 'terminating';

export type SizeFilter = 'all' | string;

export type SortKey = 'name_asc' | 'name_desc' | 'size_desc' | 'size_asc';

export type FilterState = {
  search: string;
  status: StatusFilter;
  access: AccessFilter;
  size: SizeFilter;
  sort: SortKey;
};

export const DEFAULT_FILTER_STATE: FilterState = {
  search: '',
  status: 'all',
  access: 'all',
  size: 'all',
  sort: 'name_asc',
};

export type WorkspaceRow = {
  workspace: WorkspaceT;
  databaseName: string;
};
